export class IRSStatement {
    patientId: number | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    deliveryMethod: string | undefined;
    sendTo: string | undefined;
}

